<template>
  <div>
    <mt-header :title="$t('绑定邮箱')">
      <mt-button icon="back" slot="left" @click.native="$router.back()"></mt-button>
    </mt-header>
    <div class="form">
      <mt-field class="form-item" :label="$t('邮箱')" :placeholder="$t('请输入邮箱')" v-model.trim="email"></mt-field>
      <mt-field class="form-item" :label="$t('验证码')" :placeholder="$t('请输入验证码')" v-model.trim="verification_code">
        <mt-button v-if="count === 60" size="small" @click="getCode">{{
          $t("获取验证码")
        }}</mt-button>
        <div v-else>{{ count }} s</div>
      </mt-field>
      <div style="padding: 20px">
        <mt-button block size="large" type="primary" @click="onBind">{{
          $t("绑定")
        }}</mt-button>
      </div>
    </div>
    <VerifyPopup ref="refVerify" scene="credentials_bind_email" @onVerify="onSubmit" />
    <ImageVerify scene="bind_email" :username="email" ref="imageverify" @imageCallback="imageCallback"></ImageVerify>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import VerifyPopup from "@/components/VerifyPopup";
import ImageVerify from "@/components/ImageVerify.vue";
import { httpGetCode, httpBindEmail } from "@/api/userCenter";
import { validateEmail } from "../../utils/validate";
import { httpGetUserInfo } from "@/api/login";
export default {
  components: { VerifyPopup, ImageVerify },
  data() {
    return {
      count: 60,
      email: "",
      verification_code: "",
    };
  },
  activated() {
    this.count = 60;
    this.email = "";
    this.verification_code = "";
    this.credentials = "";
  },
  methods: {
    countDown() {
      if (this.count === 0) {
        this.count = 60;
        return;
      }
      this.count--;
      setTimeout(() => {
        this.countDown();
      }, 1000);
    },
    // 点击获取验证码事件
    getCode() {
      if (this.email == "") {
        Toast(this.$t("请输入邮箱"));
        return;
      }
      // httpGetCode({ username: this.email, scene: "bind_email" }).then(
      //   ({ msg }) => {
      //     Toast(msg);
      //     this.countDown();
      //   }
      // );
      // 图片验证
      this.$refs.imageverify.run()
    },
    imageCallback() {

      this.countDown();
    },

    //点击绑定
    onBind() {
      if (!this.email) {
        Toast(this.$t("请输入邮箱"));
        return;
      } else if (!validateEmail(this.email)) {
        Toast(this.$t("邮箱地址不符合格式"));
        return;
      }
      if (!this.verification_code) {
        Toast(this.$t("请输入验证码"));
        return;
      }
      if (this.credentials) {
        this.onSubmit(this.credentials);
      } else {
        this.$refs.refVerify.show = true;
      }
    },
    onSubmit(credentials) {
      this.credentials = credentials;
      const payload = {
        email: this.email,
        verification_code: this.verification_code,
      };
      if (parseInt(Date.now() / 1000) > credentials.expiretime) {
        this.$refs.refVerify.show = true;
        return false;
      } else {
        payload.credentials = credentials.credentials;
      }
      httpBindEmail(payload).then(({ msg }) => {
        Toast(msg);
        httpGetUserInfo();
        this.$router.back();
      });
    },
  },
};
</script>

<style scoped>
.mint-header {
  background: #ffffff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}

.form-item {
  border-bottom: 1px solid #f6f6f6;
}
</style>
